import {  ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
interface Item {
    code: string;
    name: string;
    selected?: boolean;
    description?: string;
}

@Component({
    selector: 'clever-selectionbtn',
    templateUrl: './selectionbtn.component.html',
    styleUrls: ['./selectionbtn.component.scss'],
    standalone: false
})
export class SelectionbtnComponent implements OnInit, OnChanges {
    @Input() mode: string;
    @Input() isCheckBox: boolean = false;
    @Input() title: string;
    @Input() list: Item[];
    @Output() sendRes: EventEmitter<Item []> = new EventEmitter();
    slicenbr: number = 5;
    constructor(
        protected cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['list']?.isFirstChange() && changes['list']?.currentValue) {
            this.list = changes['list'].currentValue;
            this.cdr.detectChanges();
        }
    }

    selectItem(item: Item) {
        item.selected = !item.selected;
        this.sendRes.emit(this.list);
    }

    showMore(all) {
        this.slicenbr = all;
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }
}
